import { TgMailing } from "@/modules/telegram/interfaces"
import { SerializedPage } from "./types"

/** Сериализация один раз: байты переиспользуются при всех ретраях и дозаливе. */
export const serializePage = (
  pageIndex: number,
  messages: TgMailing.CallApiBody[],
): SerializedPage => ({
  pageIndex,
  bodyJson: JSON.stringify({ pageIndex, messages }),
})
